// extracted by mini-css-extract-plugin
export default {"title":"styles_title__LaV6F","bookingsList":"styles_bookingsList__DotQ2","loading":"styles_loading__7h5+y","filtersContainer":"styles_filtersContainer__PruV3"};